import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

interface MobileSliderProps {
  children: React.ReactNode;
}

const MobileSlider: React.FC<MobileSliderProps> = ({ children }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  //const timerRef = useRef<NodeJS.Timeout | null>(null);

  // Autoplay plugin
  const autoplay = (slider: any) => {
    let timeout: ReturnType<typeof setTimeout>;
    let mouseOver = false;

    const clearNextTimeout = () => {
      clearTimeout(timeout);
    };
    const nextTimeout = () => {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        slider.next();
      }, 3000); // change slide every 3s
    }

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });
    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
  };

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      initial: 0.1,
      loop: true,
      slides: {
        perView: 1.2,
        spacing: 15,
        origin: "center", // center the active slide
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    [autoplay] // pass autoplay as plugin
  );

  return (
    <div className="md:hidden block">
      <div ref={sliderRef} className="keen-slider">
        {React.Children.map(children, (child, idx) => (
          <div className="keen-slider__slide" key={idx}>
            {child}
          </div>
        ))}
      </div>

      {/* Dots */}
      {loaded && instanceRef.current && (
        <div className="flex justify-center items-center gap-2 px-[24px] py-[24px] bg-transparent mt-[32px] max-w-[244px] mx-auto">
          {Array.from({
            length: instanceRef?.current?.track?.details?.slides?.length || 0,
          }).map((_, idx) => (
            <button
              aria-label="dot"
              key={idx}
              onClick={() => instanceRef.current?.moveToIdx(idx)}
              className={`p-0 relative overflow-hidden ${
                currentSlide === idx
                  ? "flex-1 min-w-[60px] w-16 h-1 transition-none bg-[#fff]"
                  : "flex-none w-4 h-1 bg-[#fff]"
              }`}
            >
              <span
                className={`absolute top-0 left-0 w-full h-1 ${
                  currentSlide === idx
                    ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[2000ms] delay-[200ms]"
                    : "left-[-100%] transition-none"
                }`}
              ></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
export default MobileSlider;
